module.exports = __webpack_public_path__ + "img/delete-account.876b4c91.svg";